import { format, parseISO } from "date-fns";

export default function formatDate(date: string): string {
  if (!date) {
    return "-";
  }

  const only_date = !date.includes("T");

  if (only_date) {
    return format(parseISO(date), "dd/MM/yyyy");
  }

  return format(parseISO(date), "dd/MM/yyyy 'às' HH':'mm':'ss");
}
